export const Create = {
  FilesToUpload: "filesToUpload" as const,
  Date: "date" as const,
  Template: "template" as const,
  TemplateId: "templateId" as const,
  SalesItems: "salesItems" as const,
  PaymentItems: "paymentItems" as const,
  OtherItems: "otherItems" as const,
  Dimensions: "dimensions" as const,
  HasRowLevelDimensions: "hasRowLevelDimensions" as const,
  SalesTotalAmount: "salesTotalAmount" as const,
  PaymentsTotalAmount: "paymentsTotalAmount" as const,
  OthersTotalAmount: "othersTotalAmount" as const,
  Total: "total" as const,
}

export const EditTagsRow = {
  Id: "id" as const,
  Description: "description" as const,
  Dimensions: "dimensions" as const,
}

export const EditTags = {
  EditInRows: "editInRows" as const,
  ReportRows: "reportRows" as const,
  SalesRows: "salesRows" as const,
  PaymentRows: "paymentRows" as const,
  OtherRows: "otherRows" as const,
}

export const RevenueReportItem = {
  TemplateItemId: "templateItemId" as const,
  Account: "account" as const,
  AccountType: "accountType" as const,
  Description: "description" as const,
  Amount: "amount" as const,
  Dimensions: "dimensions" as const,
  Category: "category" as const,
  VatAccount: "vatAccount" as const,
  VatRate: "vatRate" as const,
}

export const Filter = {
  Date: "date" as const,
  TemplateId: "templateId" as const,
  Template: "template" as const,
  Status: "status" as const,
  RegisteredBy: "registeredBy" as const,
  RegisteredById: "registeredById" as const,
  SaleAmount: "saleAmount" as const,
  DifferenceAmount: "differenceAmount" as const,
  HideLegacy: "hideLegacy" as const,
}

